import { useFeatureFlag, FeatureFlagVariationValue, JSONValue } from '@moda/portal-stanchions';

type CutoffDates = {
  standard: string;
  express: string;
  overnight: string;
};

type HolidayCutoff = {
  arrivalDate: string;
  cutoffDates: {
    west: CutoffDates;
    midwest: CutoffDates;
    east: CutoffDates;
    asia: CutoffDates;
    europe: CutoffDates;
  };
};

export type Region = keyof HolidayCutoff['cutoffDates'];

const isCutoffDates = (value: JSONValue): value is CutoffDates =>
  value != null &&
  typeof value === 'object' &&
  'standard' in value &&
  typeof value.standard === 'string' &&
  'express' in value &&
  typeof value.express === 'string' &&
  'overnight' in value &&
  typeof value.overnight === 'string';

const isHolidayCutoff = (value: FeatureFlagVariationValue): value is HolidayCutoff =>
  value != null &&
  typeof value === 'object' &&
  'arrivalDate' in value &&
  typeof value.arrivalDate === 'string' &&
  'cutoffDates' in value &&
  value.cutoffDates != null &&
  typeof value.cutoffDates === 'object' &&
  'west' in value.cutoffDates &&
  isCutoffDates(value.cutoffDates.west) &&
  'midwest' in value.cutoffDates &&
  isCutoffDates(value.cutoffDates.midwest) &&
  'east' in value.cutoffDates &&
  isCutoffDates(value.cutoffDates.east) &&
  'asia' in value.cutoffDates &&
  isCutoffDates(value.cutoffDates.asia) &&
  'europe' in value.cutoffDates &&
  isCutoffDates(value.cutoffDates.europe);

export const useHolidayCutoff = () =>
  useFeatureFlag('holiday-shipping-cutoff', [
    { default: null },
    { getFromTreatment: treatment => (isHolidayCutoff(treatment) ? treatment : null) }
  ]);
